/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as RateCapTypes from './types'

export type LoanRateCapsGetKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'rate-caps',
  unknown,
]

export type LoanRateCapsGetResponse = RateCapTypes.ResponseRateCapsArray

export type LoanRateCapsGetVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: void
}

export const loanRateCapsGet = makeData<
  LoanRateCapsGetResponse,
  LoanRateCapsGetKey,
  LoanRateCapsGetVariables
>({
  method: 'get',
  name: 'loanRateCapsGet',
  summary: 'Get loan rate caps',
  path: '/people/{personId}/loans/{loanId}/rate-caps',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'rate-caps',
    query,
  ],
})

export type LoanRateCapAddKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'rate-caps',
  unknown,
]

export type LoanRateCapAddResponse = RateCapTypes.ResponseRateCap

export type LoanRateCapAddVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: RateCapTypes.RequestBodyRateCapAdd
  query?: void
}

export const loanRateCapAdd = makeData<
  LoanRateCapAddResponse,
  LoanRateCapAddKey,
  LoanRateCapAddVariables
>({
  method: 'post',
  name: 'loanRateCapAdd',
  summary: 'Add loan rate cap',
  path: '/people/{personId}/loans/{loanId}/rate-caps',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'rate-caps',
    query,
  ],
})

export type LoanRateCapUpdateKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'rate-caps',
  string | undefined,
  unknown,
]

export type LoanRateCapUpdateResponse = RateCapTypes.ResponseRateCap

export type LoanRateCapUpdateVariables = {
  personId: string | undefined
  loanId: string | undefined
  rateCapId: string | undefined
  body?: RateCapTypes.RequestBodyRateCapUpdate
  query?: void
}

export const loanRateCapUpdate = makeData<
  LoanRateCapUpdateResponse,
  LoanRateCapUpdateKey,
  LoanRateCapUpdateVariables
>({
  method: 'put',
  name: 'loanRateCapUpdate',
  summary: 'Update loan rate cap',
  path: '/people/{personId}/loans/{loanId}/rate-caps/{rateCapId}',
  queryKey: ({ query, personId, loanId, rateCapId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'rate-caps',
    rateCapId,
    query,
  ],
})

export type LoanRateCapDeleteKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'rate-caps',
  string | undefined,
  unknown,
]

export type LoanRateCapDeleteResponse = RateCapTypes.ResponseRateCapDeleted

export type LoanRateCapDeleteVariables = {
  personId: string | undefined
  loanId: string | undefined
  rateCapId: string | undefined
  body?: void
  query?: void
}

export const loanRateCapDelete = makeData<
  LoanRateCapDeleteResponse,
  LoanRateCapDeleteKey,
  LoanRateCapDeleteVariables
>({
  method: 'delete',
  name: 'loanRateCapDelete',
  summary: 'Delete loan rate cap',
  path: '/people/{personId}/loans/{loanId}/rate-caps/{rateCapId}',
  queryKey: ({ query, personId, loanId, rateCapId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'rate-caps',
    rateCapId,
    query,
  ],
})

export type DrawRateCapsGetKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'rate-caps',
  unknown,
]

export type DrawRateCapsGetResponse = RateCapTypes.ResponseRateCapsArray

export type DrawRateCapsGetVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  body?: void
  query?: void
}

export const drawRateCapsGet = makeData<
  DrawRateCapsGetResponse,
  DrawRateCapsGetKey,
  DrawRateCapsGetVariables
>({
  method: 'get',
  name: 'drawRateCapsGet',
  summary: 'Get draw rate caps',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rate-caps',
  queryKey: ({ query, personId, loanId, drawId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'rate-caps',
    query,
  ],
})

export type DrawRateCapAddKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'rate-caps',
  unknown,
]

export type DrawRateCapAddResponse = RateCapTypes.ResponseRateCap

export type DrawRateCapAddVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  body?: RateCapTypes.RequestBodyRateCapAdd
  query?: void
}

export const drawRateCapAdd = makeData<
  DrawRateCapAddResponse,
  DrawRateCapAddKey,
  DrawRateCapAddVariables
>({
  method: 'post',
  name: 'drawRateCapAdd',
  summary: 'Add draw rate cap',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rate-caps',
  queryKey: ({ query, personId, loanId, drawId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'rate-caps',
    query,
  ],
})

export type DrawRateCapUpdateKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'rate-caps',
  string | undefined,
  unknown,
]

export type DrawRateCapUpdateResponse = RateCapTypes.ResponseRateCap

export type DrawRateCapUpdateVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  rateCapId: string | undefined
  body?: RateCapTypes.RequestBodyRateCapUpdate
  query?: void
}

export const drawRateCapUpdate = makeData<
  DrawRateCapUpdateResponse,
  DrawRateCapUpdateKey,
  DrawRateCapUpdateVariables
>({
  method: 'put',
  name: 'drawRateCapUpdate',
  summary: 'Update draw rate cap',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rate-caps/{rateCapId}',
  queryKey: ({ query, personId, loanId, drawId, rateCapId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'rate-caps',
    rateCapId,
    query,
  ],
})

export type DrawRateCapDeleteKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'rate-caps',
  string | undefined,
  unknown,
]

export type DrawRateCapDeleteResponse = RateCapTypes.ResponseRateCapDeleted

export type DrawRateCapDeleteVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  rateCapId: string | undefined
  body?: void
  query?: void
}

export const drawRateCapDelete = makeData<
  DrawRateCapDeleteResponse,
  DrawRateCapDeleteKey,
  DrawRateCapDeleteVariables
>({
  method: 'delete',
  name: 'drawRateCapDelete',
  summary: 'Delete draw rate cap',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/rate-caps/{rateCapId}',
  queryKey: ({ query, personId, loanId, drawId, rateCapId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'rate-caps',
    rateCapId,
    query,
  ],
})
